import { Link, NavLink, useNavigate } from "react-router-dom";
import { LogOut, LayoutDashboard } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useAuth } from "@/context/AuthContext";
import { RoleBadge } from "@/components/RoleBadge";
import { Avatar } from "@/components/Avatar";

const links = [
  { to: "/", label: "Feed" },
  { to: "/explore", label: "Find a nail tech" },
  { to: "/community", label: "Tech community" },
];

const NavLinks = () =>
  links.map((l) => (
    <NavLink key={l.to} to={l.to}  data-testid={`nav-${l.to.slice(1) || "feed"}`} end={l.to === "/"}
      className={({ isActive }) => `text-sm transition-colors hover:text-pink-600 ${isActive ? "text-pink-600" : "text-stone-700"}`}>
      {l.label}
    </NavLink>
  ));

const UserMenu = ({ user, logout }) => {
  const nav = useNavigate();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger data-testid="user-menu-trigger" className="flex items-center gap-2 rounded-full border bg-white py-1 pl-1 pr-3">
        <Avatar user={user} />
        <span className="font-mono text-xs">@{user.username}</span>
        <RoleBadge role={user.role} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem data-testid="menu-dashboard" onClick={() => nav("/dashboard")}><LayoutDashboard className="mr-2 h-4 w-4" />My profile</DropdownMenuItem>
        <DropdownMenuItem data-testid="menu-logout" onClick={async () => { await logout(); nav("/"); }}><LogOut className="mr-2 h-4 w-4" />Log out</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export const Header = () => {
  const { user, claim, logout } = useAuth();
  const joinLabel = claim?.status === "pending" ? "Finish verifying" : "Join with Instagram";
  return (
    <header className="sticky top-0 z-50 border-b border-[#EAE4DC] bg-[#FAF7F2]/85 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-12">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-2">
          <img src="/nailora-logo.webp" alt="Nailora" data-testid="brand-logo-img" className="h-9 w-auto sm:h-11" />
        </Link>
        <nav className="hidden items-center gap-8 md:flex"><NavLinks /></nav>
        <div className="flex items-center gap-3">
          {user ? <UserMenu user={user} logout={logout} /> : (
            <Link to="/join" data-testid="header-join-button" className="hidden rounded-full bg-stone-900 px-5 py-2 text-sm text-white transition-colors hover:bg-pink-600 sm:block">
              {joinLabel}
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};
